import AxesTitles from './AxesTitles';
import { AXES_TITLES_WIDGETS } from './constants';
export default AxesTitles;
export { AXES_TITLES_WIDGETS };